import React from "react";
import { StatCard } from "@/components/ui";

/**
 * AllocationStats
 * Displays the 3 summary stat cards inside the Batch Allocation modal using the shared StatCard component.
 */
const AllocationStats = ({ total, allocated }) => {
  const remaining = total - allocated;
  const isOverAllocated = remaining < 0;

  // Reusable Tailwind arbitrary variants to completely restyle the StatCard internally
  // It flips the flex column (title on top, value below), centers everything, and tweaks typography.
  const baseOverride = " [&_.flex-1]:!flex [&_.flex-1]:!flex-col-reverse [&_.flex-1]:!items-center [&_p]:!mt-0 [&_p]:!mb-1 [&_p]:!tracking-widest [&_span.text-lg]:!text-base [&_span.text-lg]:!font-normal [&_.flex-1>div]:!justify-center";

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {/* Total Unassigned */}
      <StatCard
        title="Contacts not Assigned"
        value={total}
        className={`!bg-slate-50/70 border-slate-100 ${baseOverride} [&_span.text-lg]:!text-slate-700 [&_p]:!text-slate-500`}
      />

      {/* Allocated */}
      <StatCard
        title="Allocated"
        value={allocated}
        className={`!bg-blue-50/70 border-blue-100 ${baseOverride} [&_span.text-lg]:!text-brand-blue [&_p]:!text-brand-blue`}
      />

      {/* Remaining */}
      <StatCard
        title="Remaining"
        value={remaining}
        className={`transition-colors ${isOverAllocated ? '!bg-red-50/70 border-red-100' : '!bg-orange-50/70 border-orange-100'} ${baseOverride} ${isOverAllocated ? '[&_span.text-lg]:!text-red-600 [&_p]:!text-red-500' : '[&_span.text-lg]:!text-orange-600 [&_p]:!text-orange-500'}`}
      />
    </div>
  );
};

export default AllocationStats;

